/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {
    Page,
    Preload,
    WKError,
    ClickLoadMore
} from '../components'
import {
    SearchDetailLiveroomItem
} from '../components/search'
import {getJsonFromUrl, isTouchBottom} from '../utils'
import CurrencyItem from '../components/wk/WKCurrencyItem'
import '../styles/search/SearchPage.css'

class SearchDetailPage extends React.Component {

    constructor() {
        super();
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.dispatch({
            type: 'SEARCH_DETAIL_CLEAR'
        });
        const url_data = this.props.routeParams;
        const data = getJsonFromUrl();

        axios.get('/api/board/search',{
            params: {
                q: data.q,
                type: url_data.type,
            }
        }).then(res => {
            if (res.data.code === 0){
                this.props.dispatch({
                    type: 'SEARCH_DETAIL_INIT',
                    payload: res.data.data
                });
                this.props.dispatch({
                    type: 'SEARCH_DETAIL_LIST',
                    payload: res.data.data.records
                })
            }
        })

        this.detail_scroll_method = () => {
            let shouldGet = isTouchBottom(30)
            if (shouldGet && this.props.search.detail && this.props.search.detail.has_more){
                if (!this.state.loading){
                    this.setState({
                        loading: true
                    });
                    //GET LECTURE MORE
                    axios.get('/api/board/search',{
                        params: {
                            q: data.q,
                            type: url_data.type,
                            offset: this.props.search.detail && this.props.search.detail.next_offset,
                        }
                    }).then(res => {
                        if (res.data.code === 0){
                            this.props.dispatch({
                                type: 'SEARCH_DETAIL_INIT',
                                payload: res.data.data
                            });
                            let list = this.props.search.detail_list.concat(res.data.data.records);
                            this.props.dispatch({
                                type: 'SEARCH_DETAIL_LIST',
                                payload: list
                            });
                            this.setState({
                                loading: false
                            });
                        }
                    })
                }
            }
        };

        window.addEventListener('scroll',this.detail_scroll_method);

    }

    componentWillUnmount (){
        this.detail_scroll_method && window.removeEventListener('scroll',this.detail_scroll_method);
    }

    render (){
        const urlData = this.props.routeParams;
        const {search} = this.props;
        const loadingstatus = {
            ended: this.props.search.detail_init && !this.props.search.detail.has_more,
            loading: this.state.loading,
            has_more: this.props.search.detail_init && this.props.search.detail.has_more,
            loadMethod: () => {}
        };

        if (!search.detail_init){
            return <Preload/>
        }

        return(
        <Page>
            <div className="search-detail-page">
                {urlData.type === 'liveroom' && search.detail_list && search.detail_list.length > 0 &&
                <div>
                    {search.detail_list.map((item) => <SearchDetailLiveroomItem liveroom={item} key={item.id}/>)}
                    <ClickLoadMore loadingstatus={loadingstatus}/>
                </div>
                }

                {urlData.type === 'channel' && search.detail_list && search.detail_list.length > 0 &&
                <div>
                    {search.detail_list.map((item) => <CurrencyItem content={item} type={"channel"} key={item.id}/>)}
                    <ClickLoadMore loadingstatus={loadingstatus}/>
                </div>
                }
            </div>
        </Page>
        )
    }
}

export default connect(state => ({
    search: state.search
}))(SearchDetailPage)


// WEBPACK FOOTER //
// ./src/pages/SearchDetailPage.js